<app-main-menu></app-main-menu>
<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 10000;">
  <ng-template #notificationWrapper></ng-template>
</div>
<router-outlet></router-outlet>